import type { SavedCard } from "@/api/services";

/**
 * Saved cards that can actually be charged.
 *
 * A card is unchargeable when its provider has no integration able to settle
 * a stored-token charge — Paymob without a MOTO integration, for instance,
 * answers `success=false, is_3ds=true` and the payment never converts.
 * Offering such a card at checkout guarantees a failed order, so the payment
 * service marks it `chargeable: false` and we hide it.
 *
 * The flag is treated as opt-out: a backend that does not send it yet leaves
 * the card visible, so a stale deploy degrades to today's behaviour rather
 * than hiding every card.
 */
export function chargeableSavedCards(cards: SavedCard[]): SavedCard[] {
  return cards.filter((card) => card.chargeable !== false);
}
